<!-- 登录情况 -->
<template>
  <Card :bordered="true" dis-hover>
    <p slot="title">
      <slot name="title"></slot>
    </p>
    <!-- <a href="#" slot="extra"><slot name="extra"></slot></a> -->
    <div class="login-status-big">
      <div class="login-data">
        <div class="data-top">
          <count-to
            :end="loginData.yesterdayCount"
            count-class="count-style color-green"
          />
          <span class="count-label">{{ $t('home.user_login') }}</span>
        </div>
        <div class="data-top">
          <count-to
            :end="loginData.yesterdayNoCount"
            count-class="count-style color-red"
          />
          <span class="count-label">{{ $t('home.user_unlogin') }}</span>
        </div>
      </div>
      <div class="data-bottom">
        <count-to :end="loginData.total" count-class="count-style" />
        <span class="count-label">{{ $t('home.user_total') }}</span>
      </div>
    </div>
  </Card>
</template>

<script>
import api from '../../../api/home/index';
import CountTo from '../../../components/count-to/index';
import moment from 'moment';
export default {
  components: { CountTo },
  data() {
    return {
      loginData: {
        yesterdayCount: 0,
        yesterdayNoCount: 0,
        total: 0,
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      api
        .countLogsNew({
          startDate: moment().subtract(1, 'days').format('YYYY-MM-DD'),
        })
        .then(res => {
          if (res) {
            this.loginData = res;
          }
        })
        .catch(error => {
          console.error(`${this.$t('home.error_getlogindatav')}:${error}`);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .ivu-card-body {
    padding-top: 0;
    overflow-y: auto;
  }
}
.login-status-big {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 16px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .login-data {
    display: flex;
    justify-content: space-between;
    .data-top {
      width: 48%;
      height: 88px;
      text-align: center;
      margin: 10px 0;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 8px;
      padding: 22px 0;
    }
  }
  .data-bottom {
    margin: 0 auto;
    margin-top: 12px;
    width: 100%;
    height: 88px;
    text-align: center;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 8px;
    padding: 22px 0;
  }
  .count-label {
    color: rgba(255, 255, 255, 0.5);
  }
}
</style>
